import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9c5641f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 1 }

import StrategySetting from './components/strategy-setting.vue'
import { ref, onMounted, watch, nextTick, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  getActionStateLabelMap,
  getDirectionStateLabelMap,
  getProtocolStateLabelMap,
} from './ip-address-blocking-labels'

import { PolicySettingType, PolicyType } from '@/views/dashboard/_enum/policy-type'
import { StrategyListDataCommon, PolicyCommonService } from '../../policy/policy-common.service'
import { PermissionFe, ServicePermissionService } from '@/services/service-permission.service'
import { useRouter } from 'vue-router'
import PolicyManage from '@/views/dashboard/_components/policy-manage/policy-manage.vue'
import { TableOptColumn, TableOpt, TableActOpt } from '@/components/cmTable/types'
import { GroupRefreshManage } from '@/services/group'
import Keywords from '../../data-safe/anti-external-control/components/Keywords.vue'
import TaskTimeShow from '../../_components/task-time/task-time-show.vue'
import PageSubscribeBar from '@/views/dashboard/_components/subscribe-bar/page-subscribe-bar.vue'
import Card from '@/views/dashboard/_components/card/card.vue'
import StatisticsCards from './_components/statistics-cards.vue'
import IpBlockingTrendChart from './_components/ip-blocking-trend-chart.vue'
import IpBlockingRankingChart from './_components/ip-blocking-ranking-chart.vue'
import { FormSize, FormSizeType } from '@/components/cmForm/types'
import { TerminalType } from '@/views/dashboard/_enum/terminal-type'
import RawDataDrawer from '@/views/dashboard/_components/raw-data-drawer/raw-data-drawer.vue'
import { IpLogRow, TerminalNetIpLimitListService } from './service'
import IpAccessEventList from '../port-manage/_components/ip-access-event-list/ip-access-event-list.vue'
import { TableViewMode } from '@/views/dashboard/_enum/table-view-mode'
import dayjs from 'dayjs'
import { formatTimeStamp, getTimeRangeByEnum } from '@/utils/time'
import { TimeRange, TimeGranularity, TimeFormat } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import type { IpAddressBlockingStatCardKey } from './_components/ip-address-blocking-statistics-cards.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, locale } = useI18n()
const injector = useReflectiveInjector([PolicyCommonService, TerminalNetIpLimitListService])
const groupRefreshManage = injector.get(GroupRefreshManage)
const groupPolicySettingsService = injector.get(PolicyCommonService)
const terminalNetIpLimitListService = injector.get(TerminalNetIpLimitListService)
const servicePermissionService = injector.get(ServicePermissionService)
const router = useRouter()
const hasPermission = servicePermissionService.getHasPermission(PermissionFe.internet_ip_limit)
const formSize: FormSizeType = FormSize.Small

// 编辑api
const saveOrUpdateApi = groupPolicySettingsService.saveSettings.bind(groupPolicySettingsService)
// 获取当前策略
const getApi = groupPolicySettingsService.getSettings.bind(groupPolicySettingsService)
const visible = ref(false)
const policyManageRef = ref()
const activeRow = ref({} as StrategyListDataCommon)
const fromGroupId = ref()

// --- Statistics Data ---
  const todayBlockedIPs = ref(0)
  const effectivePolicies = ref(0)
// --- Chart Data ---
const rankingTimeRange = ref<TimeRange>(TimeRange.DAYS_30)
const trendTimeRange = ref<TimeRange>(TimeRange.DAYS_30)
const trendChartData = ref({
  times: [] as string[],
  counts: [] as number[]
})

const rankingData = ref<Array<{ ip: string; count: number }>>([])

// --- Log Table ---
const ipAccessEventListRef = ref()
const ipBlockingRankingChartRef = ref()
const isShowRawData = ref(false)
const rawDataRow = ref<IpLogRow>({} as IpLogRow)
const ipAccessEventDrawerVisible = ref(false)
const ipAccessEventDrawerKey = ref(0)
const ipAccessEventDrawerEmbed = ref<{
  dateRange?: [string, string]
  keyWord?: string
  strategyId?: string
} | null>(null)
/** 首页预览列表：排行点击等写入 keyword / 日期，驱动搜索框与列表 */
const ipAccessEventPreviewEmbed = ref<{ dateRange?: [string, string]; keyWord?: string }>({})

function viewAllIpAccessEvents() {
  if (!hasPermission) return
  ipAccessEventDrawerEmbed.value = null
  ipAccessEventDrawerKey.value += 1
  ipAccessEventDrawerVisible.value = true
}

function handleIpAddressBlockingStatClick(_key: IpAddressBlockingStatCardKey) {
  if (todayBlockedIPs.value <= 0) return
  const d = dayjs().format('YYYY-MM-DD')
  ipAccessEventDrawerEmbed.value = { dateRange: [d, d] }
  ipAccessEventDrawerKey.value += 1
  ipAccessEventDrawerVisible.value = true
}

function triggerTimeCallback(item: StrategyListDataCommon) {
  const id = item?.id
  if (id == null || id === '') return
  const end = dayjs().format('YYYY-MM-DD')
  const start = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
  ipAccessEventDrawerEmbed.value = {
    dateRange: [start, end],
    strategyId: String(id),
  }
  ipAccessEventDrawerKey.value += 1
  ipAccessEventDrawerVisible.value = true
}

function handleIpBlockingRankRowClick(payload: { ip: string }) {
  if (!payload.ip) return
  const [startSec, endSec] = getTimeRangeByEnum(rankingTimeRange.value)
  const embed: { dateRange?: [string, string]; keyWord?: string } = { keyWord: payload.ip }
  if (startSec !== undefined && endSec !== undefined) {
    embed.dateRange = [
      dayjs.unix(startSec).format('YYYY-MM-DD'),
      dayjs.unix(endSec).format('YYYY-MM-DD'),
    ]
  }
  ipAccessEventPreviewEmbed.value = { ...embed }
  ipAccessEventDrawerEmbed.value = embed
  ipAccessEventDrawerKey.value += 1
  ipAccessEventDrawerVisible.value = true
}
const customCols = computed<TableOptColumn[]>(() => {
  const _localeDep = locale.value
  const actionLabels = getActionStateLabelMap(t)
  const directionLabels = getDirectionStateLabelMap(t)
  const protocolLabels = getProtocolStateLabelMap(t)
  return [
  {
    label: t('ipAddressBlocking.executeAction'),
    prop: 'action',
    minWidth: 160 ,
    formatter: (_row) => actionLabels[_row.strategy.action] || t('ipAddressBlocking.unknown')
  },
  {
    label: t('ipAddressBlocking.interceptDirection'),
    prop: 'direction',
    columnOpt: { minWidth: 140 },
    formatter: (_row) => directionLabels[_row.strategy.direction] || t('ipAddressBlocking.unknown')
  },
  {
    label: t('ipAddressBlocking.executeTime'),
    prop: 'frequency',
    minWidth: 160
  },
  {
    label: t('ipAddressBlocking.protocol'),
    prop: 'protocol',
    columnOpt: { minWidth: 140 },
    formatter: (_row) => protocolLabels[_row.strategy.protocol] || t('ipAddressBlocking.unknown')
  },
  {
    label: t('ipAddressBlocking.localPort'),
    prop: 'local_port',
    columnOpt: { minWidth: 160 }
  },
  {
    label: t('ipAddressBlocking.remoteIp'),
    prop: 'remote_ip',
    columnOpt: { minWidth: 230 }
  },
  {
    label: t('ipAddressBlocking.remotePort'),
    prop: 'remote_port',
    columnOpt: { minWidth: 160 }
  },
]
})
const handleAction = ({ type, ...other }: { type: string;[type: string]: any; }) => {
  console.log(type, other)
  const { validGroupId } = policyManageRef.value
  const types: any = {
    add: () => {
      visible.value = true
      activeRow.value = {} as StrategyListDataCommon
      fromGroupId.value = validGroupId
    },
    edit: async () => {
      visible.value = true
      activeRow.value = other.rowItem
      fromGroupId.value = undefined
    },
  }
  types?.[type]?.()
}

function handleRefresh() {
  groupRefreshManage.refreshGroup()
  policyManageRef.value.tableRef.getList()
}


// 加载统计数据
async function loadStatistics() {
  if (!hasPermission) return

  try {
    // 获取今日的时间范围（从今天0点到现在）
    const now = Math.floor(dayjs().valueOf() / 1000)
    const todayStart = Math.floor(dayjs().startOf('day').valueOf() / 1000)

    const res = await terminalNetIpLimitListService.getTerminalIpaccessOverviewStat({
      start_time: todayStart.toString(),
      end_time: now.toString()
    })

    todayBlockedIPs.value = res.today_blocked_ip_count || 0
    console.log('res.today_blocked_ip_count', res.today_blocked_ip_count)
    effectivePolicies.value = res.active_policy_count || 0
  } catch (error) {
    console.error('加载统计数据失败:', error)
  }
}

// 加载趋势图数据
async function loadTrendData() {
  if (!hasPermission) return

  try {
    const [start_time, end_time] = getTimeRangeByEnum(trendTimeRange.value)

    if (start_time === undefined || end_time === undefined) {
      trendChartData.value = {
        times: [],
        counts: []
      }
      return
    }

    // 转换粒度：hour -> "hour", day -> "day"
    let granularity = 'hour' // 默认按小时
    if (trendTimeRange.value === TimeRange.DAYS_7 || trendTimeRange.value === TimeRange.DAYS_30) {
      granularity = 'day' // 按天
    }

    const res = await terminalNetIpLimitListService.getTerminalIpaccessTrendStat({
      start_time: start_time.toString(),
      end_time: end_time.toString(),
      granularity: granularity
    })

    const timePoints = res.time_points ?? []
    const blockCountList = res.block_count_list ?? []
    const timeDescList = res.time_desc_list ?? []
    const timeFormat = TimeFormat[trendTimeRange.value] || 'MM-DD HH:mm'

    const counts = blockCountList.map((c) => c ?? 0)
    const times = counts.map((_, i) => {
      const desc = timeDescList[i]
      if (desc) {
        return desc
      }
      const tp = timePoints[i]
      if (tp != null && String(tp) !== '') {
        return formatTimeStamp(Number(tp), timeFormat)
      }
      return ''
    })

    trendChartData.value = {
      times,
      counts
    }
  } catch (error) {
    console.error('加载趋势图数据失败:', error)
    trendChartData.value = {
      times: [],
      counts: []
    }
  }
}

// 加载排行数据
async function loadRankingData() {
  if (!hasPermission) return

  if (ipBlockingRankingChartRef.value) {
    ipBlockingRankingChartRef.value.loading = true
  }
  try {
    const [start_time, end_time] = getTimeRangeByEnum(rankingTimeRange.value)

    const params: any = {
      top_count: 5
    }
    if (start_time !== undefined && end_time !== undefined) {
      params.start_time = start_time.toString()
      params.end_time = end_time.toString()
    }

    const res = await terminalNetIpLimitListService.getTerminalIpaccessTopIpStat(params)

    rankingData.value = (res.top_ip_list || []).map(item => ({
      ip: item.ip_address || t('ipAddressBlocking.unknown'),
      count: item.block_count || 0
    }))
  } catch (error) {
    console.error('加载排行数据失败:', error)
    rankingData.value = []
  } finally {
    if (ipBlockingRankingChartRef.value) {
      ipBlockingRankingChartRef.value.loading = false
    }
  }
}

// 趋势图时间范围变化
function handleTrendTimeRangeChange(value: TimeRange) {
  loadTrendData()
}

// 监听排行图时间范围变化
watch(rankingTimeRange, () => {
  loadRankingData()
})

onMounted(async () => {
  await nextTick()
  if (hasPermission) {
    loadStatistics()
    loadTrendData()
    loadRankingData()
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageSubscribeBar, {
      "normal-permission-key": _unref(PermissionFe).internet_ip_limit
    }, null, 8, ["normal-permission-key"]),
    _createVNode(StatisticsCards, {
      today: todayBlockedIPs.value,
      "effective-policies": effectivePolicies.value,
      onStatClick: handleIpAddressBlockingStatClick
    }, null, 8, ["today", "effective-policies"]),
    _createVNode(_component_el_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 18,
          style: {"height":"360px"}
        }, {
          default: _withCtx(() => [
            _createVNode(IpBlockingTrendChart, {
              modelValue: trendTimeRange.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((trendTimeRange).value = $event)),
              data: trendChartData.value,
              onTimeRangeChange: handleTrendTimeRangeChange
            }, null, 8, ["modelValue", "data"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(IpBlockingRankingChart, {
              ref_key: "ipBlockingRankingChartRef",
              ref: ipBlockingRankingChartRef,
              "time-range": rankingTimeRange.value,
              "onUpdate:timeRange": _cache[1] || (_cache[1] = ($event: any) => ((rankingTimeRange).value = $event)),
              data: rankingData.value,
              onRowClick: handleIpBlockingRankRowClick
            }, null, 8, ["time-range", "data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(Card, {
      size: "second",
      title: _ctx.$t('ipAddressBlocking.ipAccessEventTitle'),
      class: "cm-ui-mt16 cm-ui-mb16",
      onViewMore: viewAllIpAccessEvents,
      "view-more-disabled": !_unref(hasPermission),
      viewMoreText: _ctx.$t('ipAddressBlocking.viewAll'),
      viewMoreButtonType: ""
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tooltip, {
          placement: "top",
          effect: "light"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('ipAddressBlocking.interceptLogTip')), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("i", null, [
              _createVNode(_component_CmSvgIcon, {
                name: "assets/icons/warn-border-gray",
                size: 18,
                class: "ip-access-event-log-tip-icon",
                monochrome: ""
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(IpAccessEventList, {
          ref_key: "ipAccessEventListRef",
          ref: ipAccessEventListRef,
          "show-preview-search": "",
          "embed-defaults": ipAccessEventPreviewEmbed.value
        }, null, 8, ["embed-defaults"])
      ]),
      _: 1
    }, 8, ["title", "view-more-disabled", "viewMoreText"]),
    _createVNode(PolicyManage, {
      title: _ctx.$t('ipAddressBlocking.policyList'),
      ref_key: "policyManageRef",
      ref: policyManageRef,
      "normal-permission-key": _unref(PermissionFe).internet_ip_limit,
      "strategy-type": _unref(PolicyType).ip_address_blocking,
      "custom-cols": customCols.value,
      "data-type": _unref(PolicySettingType).ip_address_blocking,
      "show-group-selector": true,
      "terminal-type": [_unref(TerminalType).windows, _unref(TerminalType).windowsServer],
      "trigger-time-callback": triggerTimeCallback,
      onHandleAction: handleAction
    }, {
      table__remote_ip: _withCtx(({ row }) => [
        _createVNode(Keywords, {
          "max-count": 1,
          maxChars: 20,
          keywords: row.strategy.remote_ip,
          stringType: ""
        }, null, 8, ["keywords"])
      ]),
      table__remote_port: _withCtx(({ row }) => [
        (row.strategy.remote_port?.filter?.(item => Boolean(item?.trim?.()))?.length)
          ? (_openBlock(), _createBlock(Keywords, {
              key: 0,
              "max-count": 2,
              keywords: row.strategy.remote_port,
              stringType: ""
            }, null, 8, ["keywords"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('ipAddressBlocking.allPorts')), 1))
      ]),
      table__frequency: _withCtx(({ row }) => [
        _createVNode(TaskTimeShow, {
          frequency: row.strategy.frequency,
          "task-time": row.strategy.regular_tasks
        }, null, 8, ["frequency", "task-time"])
      ]),
      table__local_port: _withCtx(({ row }) => [
        (row.strategy.local_port?.filter?.(item => Boolean(item?.trim?.()))?.length)
          ? (_openBlock(), _createBlock(Keywords, {
              key: 0,
              "max-count": 2,
              stringType: "",
              keywords: row.strategy.local_port
            }, null, 8, ["keywords"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('ipAddressBlocking.allPorts')), 1))
      ]),
      _: 1
    }, 8, ["title", "normal-permission-key", "strategy-type", "custom-cols", "data-type", "terminal-type"]),
    _createVNode(RawDataDrawer, {
      modelValue: isShowRawData.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isShowRawData).value = $event)),
      "raw-data": rawDataRow.value
    }, null, 8, ["modelValue", "raw-data"]),
    _createVNode(_component_el_drawer, {
      size: "80%",
      title: _ctx.$t('ipAddressBlocking.allIpAccessEvents'),
      modelValue: ipAccessEventDrawerVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ipAccessEventDrawerVisible).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(IpAccessEventList, {
          key: ipAccessEventDrawerKey.value,
          viewMode: _unref(TableViewMode).full,
          "embed-defaults": ipAccessEventDrawerEmbed.value,
          style: {"padding":"10px 16px"}
        }, null, 8, ["viewMode", "embed-defaults"]))
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_drawer, {
      size: "75%",
      title: _ctx.$t('ipAddressBlocking.strategySetting'),
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((visible).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(StrategySetting, {
          modelValue: visible.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
          onRefresh: handleRefresh,
          hasPermission: _unref(hasPermission),
          api: { getApi: _unref(getApi), saveOrUpdateApi: _unref(saveOrUpdateApi) },
          id: activeRow.value.id,
          "from-group-id": fromGroupId.value
        }, null, 8, ["modelValue", "hasPermission", "api", "id", "from-group-id"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ], 64))
}
}

})